import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose, faPhotoFilm, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { map, Observable, shareReplay } from 'rxjs';

import { UiAdminModule } from '@eiq/ui';

import { FileType } from '@empathy/global/data';

import { Media } from '../../models/media.model';
import { MediaService } from '../../services/media.service';
import { MediaPickerDialogComponent } from '../media-picker/media-picker-dialog.component';

@Component({
  standalone: true,
  selector: 'eiq-media-attachments',
  templateUrl: 'media-attachments.component.html',
  styleUrls: ['./media-attachments.component.scss'],
  imports: [AsyncPipe, FontAwesomeModule, UiAdminModule]
})
export class MediaAttachmentsComponent {
  media = input([], {
    transform: (value: Media[]) => (value ?? []).map((item) => (item.url ? item : { ...item, url$: this.resolveMediaUrl(item.mediaId) }))
  });
  types = input<FileType[]>([FileType.ImageJpeg, FileType.ImagePng, FileType.ImageGif, FileType.VideoMp4]);
  multipleInd = input<boolean>(true);
  maxNumberOfFiles = input<number>(10);
  referenceId = input<string>();
  testId = input<string>();
  readonly = input<boolean>(false);

  add = output<Media[]>();
  remove = output<number>();

  fileType = FileType;

  faClose = faClose;
  faPhotoFilm = faPhotoFilm;
  faPlus = faPlus;

  private dialog = inject(MatDialog);
  private mediaService = inject(MediaService);
  private urlCache = new Map<string, Observable<string>>();

  onAdd(): void {
    const dialogRef = this.dialog.open(MediaPickerDialogComponent, {
      data: {
        types: this.types(),
        multipleInd: this.multipleInd(),
        maxNumberOfFiles: this.maxNumberOfFiles(),
        referenceId: this.referenceId()
      }
    });

    dialogRef.afterClosed().subscribe((files: Media[]) => {
      if (files?.length > 0) {
        this.add.emit(files);
      }
    });
  }

  private resolveMediaUrl(mediaId: string): Observable<string> {
    if (!this.urlCache.has(mediaId)) {
      this.urlCache.set(
        mediaId,
        this.mediaService.getMediaUrl(mediaId).pipe(
          map((media) => media.url),
          shareReplay(1)
        )
      );
    }

    return this.urlCache.get(mediaId);
  }
}
